import React, { useEffect, useState, useRef } from "react";
import DataTable from "./DataTable";
import { fetchAllUserCredits } from "../features/transaction/transactionAPI";
import { useDispatch } from "react-redux";
import { Icons } from "../constants/icon-library";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { addCreditToUser } from "../features/admin/adminSlice";

function Credits() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const dispatch = useDispatch();
  const formikRef = useRef();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const data = {
        creditedUserUuid: selectedUser.uuid,
        credits: values.credits,
      };
      await dispatch(addCreditToUser(data)).unwrap();

      await fetchAllUserCredits()
        .then((res) => {
          if (res) setUsers(res.result);
          else console.warn("No data in response", res);
        })
        .catch((err) => console.error("Failed to fetch settings", err));

      document.getElementById("modalCloseButton").click();
      resetForm();
    } catch (error) {
      console.log("---------", error);
    } finally {
      setSubmitting(false);
    }
  };

  const initialCreditValue = {
    credits: "",
  };

  const creditValueValidation = Yup.object().shape({
    credits: Yup.string()
      .trim()
      .matches(/^[0-9\s()+-]+$/, "Contains invalid characters")
      .required("Please enter points to be credited"),
  });

  const columns = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "credits", label: "Credits" },
    { key: "phone", label: "Phone Number" },
    { key: "action", label: "ACTION", alignEnd: true },
  ];

  const rowRenderer = (user) => (
    <tr key={user.org}>
      <td className="align-middle ps-3 name">{user.name || "-"}</td>
      <td className="align-middle ps-3 email">{user.email || "-"}</td>
      <td className="align-middle ps-3 credits">{user.credits || "-"}</td>
      <td className="align-middle ps-3 phone">{user.phoneNumber || "-"}</td>
      <td className="align-middle text-end">
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <i
              className={`wb ${Icons("dots")} fs-8 me-2 mt-3 align-middle`}
            ></i>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-success"
              data-bs-toggle="modal"
              data-bs-target="#addCreditModal"
              onClick={() => setSelectedUser(user)}
            >
              Add Credit
            </button>
          </div>
        </div>
      </td>
    </tr>
  );

  useEffect(() => {
    fetchAllUserCredits()
      .then((res) => {
        if (res) setUsers(res.result);
        else console.warn("No data in response", res);
      })
      .catch((err) => console.error("Failed to fetch settings", err));
  }, []);

  useEffect(() => {
    const modalEl = document.getElementById("addCreditModal");

    if (!modalEl) return;

    const handler = () => {
      if (formikRef.current) {
        formikRef.current.resetForm();
      }
    };

    modalEl.addEventListener("hidden.bs.modal", handler);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handler);
    };
  }, []);

  return (
    <div className="content">
      <div className="row">
        <DataTable
          title="Users"
          data={users}
          columns={columns}
          rowRenderer={rowRenderer}
        />
        <div
          className="modal fade"
          id="addCreditModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content bg-body-highlight p-6">
              <Formik
                innerRef={formikRef}
                initialValues={initialCreditValue}
                validationSchema={creditValueValidation}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form noValidate>
                    <div className="modal-header justify-content-between border-0 p-0 mb-2">
                      <h3 className="mb-0">Add Credits</h3>
                    </div>

                    <div className="modal-body px-0">
                      <Field
                        id="credits"
                        name="credits"
                        className="form-control"
                        autoComplete="off"
                      />

                      <ErrorMessage
                        name="credits"
                        component="div"
                        className="invalid-feedback d-block"
                      />
                    </div>

                    <div className="modal-footer border-0 pt-6 px-0 pb-0">
                      <button
                        id="modalCloseButton"
                        className="btn btn-link text-danger px-3 my-0"
                        data-bs-dismiss="modal"
                        type="button"
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary my-0"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Adding..." : "Add Credit"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Credits;
